import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import GameGuideNavigation from './Navigation';
import { prevStep, nextStep } from '../../actions/gameGuideActions';
// Popup imports
import { OpenPopup } from '../../actions/popupActions';
import { PopupTypes, PopupStates } from '../Popup/Enums';
// Game(kit) imports
import gameKit from '../../../GameKit';
// Shared imports
import settings from '../../../settings';
import { GuideStepEnum } from '../../shared';

class GuideStepContainer extends React.Component {
    onBack = () => {
        const { dispatch } = this.props;
        dispatch(prevStep());
    };

    handleNext = () => {
        const { dispatch } = this.props;
        dispatch(nextStep());
    };

    onSaveSuccess = () => {
        const { dispatch } = this.props;
        dispatch(OpenPopup(PopupTypes.SAVE, PopupStates.SUCCESS, {} ));
    }

    onSaveError = (resp) => {
        const { dispatch } = this.props;
        dispatch(OpenPopup(PopupTypes.SAVE, PopupStates.ERROR, { response: resp } ));
    }

    onSave = () => {
        // Save game
        gameKit.saveGame(this.onSaveSuccess, this.onSaveError);
    }

    NavigationSigns = () => {
        const { gameGuide } = this.props;
        const { currentStep } = gameGuide;

        return <GameGuideNavigation hide={currentStep === GuideStepEnum.INACTIVE || currentStep < GuideStepEnum.SPELER} />;
    };

    render() {
        const { title, id, children, hasSaveButton } = this.props;

        let titleEl = <h1 className="title"> {title} </h1>;
        if (title.length <= 0) {
            const { titleElement } = this.props;
            titleEl = titleElement;
        }

        let saveBtn = <></>;
        if(hasSaveButton) {
            saveBtn = (
                <button
                    type="button"
                    className="btn-save"
                    onClick={this.onSave}
                >
                    opslaan 
                    <img src={`${settings.assetsPath}img/icons/disc_smile.png`} alt="Sla op disk blij" />
                </button>
            );
        }

        return (
            <div id="step-container-wrapper">
                <div className="step-container-top">
                    <this.NavigationSigns />
                    <img src={`${settings.assetsPath}img/gamestudio_logo_stapel.svg`} alt="Game Studio" />
                    <div className="btn-save-container">
                        {saveBtn}
                    </div>
                </div>
                <div className="step-outer-container">
                    <div className="grass-tiles" />
                    <div className="step-container" id={id}>
                        {titleEl}
                        <div className="step-content">{children}</div>
                    </div>
                </div>
            </div>
        );
    }
}

GuideStepContainer.defaultProps = {
    title: '',
    titleElement: <></>,
    hasSaveButton: false
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GuideStepContainer);
